import React, { useRef } from 'react';
import DataGrid, { Button, Column, Editing, Form, Popup } from "devextreme-react/data-grid";
import { dataGridErrorHandling } from '../../utils/errorHandling';
import { GroupItem, Item } from "devextreme-react/form";
import { useDeambulazioneAusiliDataSource } from '../../datasources/DeambulazioneAusiliDataSource';

type Props = {
  onchanged?: () => void;
}

export type DeambulazioneAusiliPanelHandle = {}

const DeambulazioneAusiliPanel: React.ForwardRefRenderFunction<DeambulazioneAusiliPanelHandle> = (props, ref) => {
  const dataSource = useDeambulazioneAusiliDataSource();
  const gridRef = useRef(null);

  return (
    <React.Fragment>
      <DataGrid
        dataSource={dataSource}
        ref={gridRef}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
      >
        <Editing
          mode="popup"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true}>
          <Popup title="Traumi" showTitle={true} />
          <Form colCount={1}>
            <Item dataField="descrizione" editorType='dxTextBox' />
          </Form>
        </Editing>
        <Column type='buttons' alignment='left'/>
        <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
        <Column dataField={'descrizione'} caption={'Descrizione'} />
      </DataGrid>
    </React.Fragment>
  );
}

export default React.forwardRef(DeambulazioneAusiliPanel);
